import { actions } from './actions'

const initialState = {
  paises: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function paisesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PAISES_LOAD_REQUESTED:
      return { ...state, paises: { ...state.paises, loading: true } }
    case actions.PAISES_LOAD_SUCCEEDED:
      return {
        ...state,
        paises: { ...state.paises, data: action.payload, loading: false },
      }
    case actions.PAISES_LOAD_FILED:
      return {
        ...state,
        paises: { ...state.paises, loading: false, error: action.error },
      }
    case actions.PAIS_UPDATE_REQUESTED:
      return {
        ...state,
        paises: { ...state.paises, loading: true, error: '' },
      }
    case actions.PAIS_UPDATE_SUCCEEDED:
      return {
        ...state,
        paises: {
          ...state.paises,
          data: state.paises.data.map(pais =>
            pais.id === action.payload.id ? action.payload : pais,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.PAIS_UPDATE_FILED:
      return {
        ...state,
        paises: { ...state.paises, loading: false, error: action.error },
      }
    case actions.PAIS_INSERT_REQUESTED:
      return {
        ...state,
        paises: { ...state.paises, loading: true, error: '' },
      }
    case actions.PAIS_INSERT_SUCCEEDED:
      return {
        ...state,
        paises: {
          ...state.paises,
          data: [].concat(action.payload, state.paises.data),
          loading: false,
          error: '',
        },
      }
    case actions.PAIS_INSERT_FILED:
      return {
        ...state,
        paises: { ...state.paises, loading: false, error: action.error },
      }
    case actions.PAIS_DELETE_REQUESTED:
      return {
        ...state,
        paises: { ...state.paises, loading: true, error: '' },
      }
    case actions.PAIS_DELETE_SUCCEEDED:
      return {
        ...state,
        paises: {
          ...state.paises,
          data: state.paises.data.filter(pais => pais.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.PAIS_DELETE_FILED:
      return {
        ...state,
        paises: { ...state.paises, loading: false, error: action.error },
      }
    default:
      return state
  }
}
